import { ID } from '@griply/types';

import { LoggableError } from './get-loggable-error';

export type UnparseableBoundaryInput = {
  allDay: boolean;
  start?: string;
  end?: string;
  eventId: ID;
  connectionId?: ID;
  calendarId?: ID;
};

export type UnparseableBoundaryReport = {
  error: Error;
  context: Pick<LoggableError, 'tags' | 'extra' | 'fingerprint'>;
};

const SOURCE = 'external-calendar-boundary';

// Both apps report the same failure; one payload keeps the message, tags and fingerprint from drifting apart.
export const getUnparseableBoundaryReport = ({
  allDay,
  start,
  end,
  eventId,
  connectionId,
  calendarId,
}: UnparseableBoundaryInput): UnparseableBoundaryReport => ({
  error: new Error('Unparseable external calendar event boundary'),
  context: {
    tags: { source: SOURCE, allDay: String(allDay) },
    extra: { start, end, eventId, connectionId, calendarId },
    fingerprint: [SOURCE],
  },
});
